
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-core-technology",
      function () {
        return require("private-next-pages/our-core-technology.js");
      }
    ]);
  